import type { WorkspaceRow } from '@/types/api'
import { api } from '@/lib/api'

/**
 * Кэш списка ролей, отображаемых в поле «Назначить на» (блок «Управление» в тикете).
 * null/пусто = показывать все роли (без фильтра). Иначе — только выбранные роли.
 */
export const WORKSPACE_ASSIGNEE_ROLES_CHANGED = 'workspace-assignee-roles-changed'

const LS_KEY = 'servicedesk.workspace.assigneeVisibleRoles'

function normalize(raw: unknown): string[] | null {
  if (!Array.isArray(raw)) return null
  const keys = raw
    .map((r) => String(r || '').trim().toLowerCase())
    .filter((r) => r.length > 0)
  return keys.length ? keys : null
}

/** Синхронное чтение из кэша (для фильтрации выпадающего списка на лету). */
export function getCachedAssigneeVisibleRoles(): string[] | null {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) return null
    return normalize(JSON.parse(raw))
  } catch {
    return null
  }
}

export function writeCachedAssigneeVisibleRoles(roles: string[] | null): void {
  try {
    if (roles && roles.length) localStorage.setItem(LS_KEY, JSON.stringify(roles))
    else localStorage.removeItem(LS_KEY)
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(new CustomEvent(WORKSPACE_ASSIGNEE_ROLES_CHANGED))
}

export function applyAssigneeVisibleRolesFromRow(ws: WorkspaceRow): string[] | null {
  const roles = normalize(ws.assignee_visible_roles)
  writeCachedAssigneeVisibleRoles(roles)
  return roles
}

export async function refreshAssigneeVisibleRolesFromApi(): Promise<string[] | null> {
  const ws = await api.workspaceMe()
  return applyAssigneeVisibleRolesFromRow(ws)
}
